import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { APP_URL_HOME, COLOR_LIGHT_DARK, COLOR_VIOLET } from '../../../../const';
import { getUserUnreadMessages } from '../../../../store/slices/authSlice';
import { getUserMenuState, toggleUserMenu } from '../../../../store/slices/globalSlice';
import BurgerIcon from '../../../icons/BurgerIcon';
import LogoIcon from '../../../icons/LogoIcon';
import TopBurgerIcon from '../../../icons/TopBurgerIcon';
import styles from './styles.module.scss';

const Header = (props) => {
    const dispatch = useDispatch();
    const isMenuOpened = useSelector(getUserMenuState);
    const unreadMessages = useSelector(getUserUnreadMessages);
    const { isCatalogPage = false } = props;

    return (
        <header className={styles.header}>
            <div className={classNames('container', { ['container-landing']: isCatalogPage })}>
                <div className={styles.wrapper}>
                    <Link to={APP_URL_HOME} className={styles.logo} onClick={() => dispatch(toggleUserMenu(false))}>
                        <BurgerIcon />
                        <LogoIcon />
                    </Link>
                    <button
                        className={styles.burger}
                        onClick={() => {
                            dispatch(toggleUserMenu(!isMenuOpened));
                        }}
                    >
                        {!!unreadMessages && <span className={styles.unread}></span>}
                        <TopBurgerIcon fill={isMenuOpened ? COLOR_VIOLET : COLOR_LIGHT_DARK} />
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Header;
